import * as React from 'react';

import type { BLOCK_LIST_OL, BLOCK_LIST_TASKS, BLOCK_LIST_UL } from '@gitbook/doc-core';

type ListType = typeof BLOCK_LIST_OL | typeof BLOCK_LIST_UL | typeof BLOCK_LIST_TASKS;

type ListContextType = {
    type: ListType;
    depth: number;
};

/** Local context giving information on the block list type */
export const ListContext = React.createContext<ListContextType | null>(null);
